<hlm-sheet side="right">
  <a
    [routerLink]="['/news', article.slug]"
    class="block relative overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg dark:border-gray-700 dark:bg-gray-900 dark:hover:shadow-gray-700/30 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ring-offset-background"
  >
    <div class="aspect-video w-full overflow-hidden">
      <div
        class="h-full w-full flex items-center justify-center {{ selectedBgClassLight }} dark:{{ selectedBgClassDark }}"
      >
        <span class="text-4xl" role="img" [attr.aria-label]="article.image.text">{{ article.image.text }}</span>
      </div>
    </div>
    <div class="p-5">
      <div class="mb-3 flex items-center justify-between">
        <div class="flex items-center text-xs text-gray-500 dark:text-gray-400">
          <ng-icon hlm [size]="'xs'" [name]="'lucideClock'" class="mr-1" />
          <time [dateTime]="(article.updatedAt | date: 'yyyy-MM-dd') ?? ''">
            {{ article.updatedAt | date: 'MMM d, y, HH:mm' }}
          </time>
        </div>
        @if (article.type === 'blog') {
          <span
            hlmBadge
            variant="secondary"
            class="font-medium bg-pink-100 text-pink-800 dark:bg-pink-900 dark:text-pink-300 pointer-events-none capitalize"
          >
            <ng-icon name="lucideNotebookPen" class="mr-1.5" />
            {{ article.type }}
          </span>
        } @else {
          <span
            hlmBadge
            variant="secondary"
            class="font-medium bg-indigo-100 text-indigo-800 dark:bg-indigo-900 dark:text-indigo-300 pointer-events-none capitalize"
          >
            <ng-icon name="lucideNewspaper" class="mr-1.5" />
            {{ article.type }}
          </span>
        }
      </div>

      <h2 class="mb-2 line-clamp-2 text-lg font-medium leading-tight text-gray-900 dark:text-gray-100">
        @if (searchTerm) {
          <span [innerHTML]="article.title | highlightSearch: searchTerm"></span>
        } @else {
          {{ article.title }}
        }
      </h2>

      <p class="mb-4 line-clamp-3 text-sm text-gray-600 dark:text-gray-300">
        @if (searchTerm) {
          <span [innerHTML]="article.summary | highlightSearch: searchTerm"></span>
        } @else {
          {{ article.summary }}
        }
      </p>

      <div class="mt-4 flex items-center justify-between relative z-10">
        <button
          brnSheetTrigger
          hlmBtn
          [size]="'xsm'"
          [variant]="'ghost'"
          (click)="$event.preventDefault(); $event.stopPropagation()"
          (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"
          (keydown.space)="$event.preventDefault(); $event.stopPropagation()"
        >
          <div class="flex -space-x-2">
            @for (source of (article.sources || []).slice().reverse(); track source.url; let i = $index) {
              <div
                class="relative rounded-full border-2 border-white bg-white dark:bg-gray-900 dark:border-gray-900"
                [style.zIndex]="(article.sources || []).length - i"
              >
                <img
                  [src]="'https://cdn.brandfetch.io/' + (source.url | extractDomain) + '/?c=1idfLKJcOnJ_r6mxmuz'"
                  [alt]="source.name"
                  class="h-4 w-4 rounded-full object-cover"
                />
              </div>
            }
          </div>
          &nbsp;
          <span>{{ article.sources.length }} {{ article.sources.length === 1 ? 'source' : 'sources' }}</span>
        </button>

        <button
          hlmBtn
          [size]="'xsm'"
          [variant]="'outline'"
          (click)="$event.preventDefault(); $event.stopPropagation(); navigateToArticle()"
        >
          Read More
          <ng-icon hlm [size]="'xs'" [name]="'lucideArrowRight'" class="ml-1" />
        </button>
      </div>
    </div>
  </a>

  <hlm-sheet-content *brnSheetContent="let ctx">
    <hlm-sheet-header>
      <h3 hlmSheetTitle>Sources</h3>
    </hlm-sheet-header>
    <div class="mt-6 flex-1">
      <div class="space-y-4">
        @for (source of article.sources; track source.url) {
          <a
            [href]="source.url"
            target="_blank"
            class="flex flex-col rounded-lg border border-gray-200 p-3 transition-colors hover:bg-gray-50 dark:border-gray-700 dark:hover:bg-gray-700/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ring-offset-background"
          >
            <span>
              <span class="flex justify-between space-x-2">
                <span class="flex items-center space-x-2">
                  <img
                    [src]="'https://cdn.brandfetch.io/' + (source.url | extractDomain) + '/?c=1idfLKJcOnJ_r6mxmuz'"
                    [alt]="source.name"
                    class="h-6 w-6 rounded-full"
                  />
                  <span class="text-xs text-gray-500 dark:text-gray-400">{{ source.name }}</span>
                </span>
                <ng-icon hlm [size]="'sm'" class="ml-2 text-gray-500 dark:text-gray-400" name="lucideExternalLink" />
              </span>
              <span class="flex mt-1">
                <span class="flex flex-col overflow-hidden">
                  <span class="text-sm font-medium text-gray-900 dark:text-gray-100 truncate" [title]="article.title">
                    {{ article.title }}
                  </span>
                  <time
                    class="mt-1 text-xs text-gray-500 dark:text-gray-400"
                    [dateTime]="source.timestamp | date: 'yyyy-MM-dd'"
                  >
                    {{ source.timestamp | date: 'MMM d, y, HH:mm' }}
                  </time>
                </span>
              </span>
            </span>
          </a>
        }
      </div>
    </div>
  </hlm-sheet-content>
</hlm-sheet>
